import { decryptEmail, getQueryFromString, getStringFromQuery } from '../_utils';

//getPromise() returns a promise that resolves to a boolean saying whether or not user is an elite guest
export const eliteGuestQueryParam = () => {
	const egeParamPromise = new Promise(resolve => {
		const queryParams = getQueryFromString(
			window.location.search ? window.location.search.substring(1) : ''
		);
		const ege = queryParams.ege;
		if (sessionStorage.getItem('isEliteGuest')) {
			resolve(true);
		} else if (ege) {
			decryptEmail(ege)
				.then(() => {
					sessionStorage.setItem('isEliteGuest', 'true');
					resolve(true);
				})
				.catch(() => {
					// not an email
					resolve(false);
				});
		} else {
			resolve(false);
		}
	});
	//note .finally not supported by polyfill or edge
	egeParamPromise
		.then(() => {
			removeEGEQueryParam();
		})
		.catch(() => {
			removeEGEQueryParam();
		});
	return egeParamPromise;
};

const removeEGEQueryParam = () => {
	const queryParams = getQueryFromString(
		window.location.search ? window.location.search.substring(1) : ''
	);
	if (queryParams.ege) {
		delete queryParams.ege;
		let queryString = getStringFromQuery(queryParams);
		queryString = queryString ? '?' + queryString : '';
		window.history.replaceState(
			{},
			document.title,
			location.origin + location.pathname + queryString + location.hash
		);
	}
};
